import { Outcome } from '../../models/outcome/Outcome'

const getLatestOutcome = (outcomes?: Outcome[]): Outcome | undefined => {
  if (!outcomes || outcomes.length === 0) return undefined
  return outcomes.reduce((latest, current) => {
    if (!current.date_created) return latest
    if (!latest.date_created) return current
    return new Date(current.date_created) > new Date(latest.date_created) ? current : latest
  }, outcomes[0])
}

// ICE-6641: client.self_harm on the profile payload can remain false even when
// the submitted assessment indicates self-harm (task and outcome are written,
// but the denormalized flag is not). Derive from the latest outcome as a fallback.
export const hasSelfHarmFromLatestOutcome = (outcomes?: Outcome[]): boolean => {
  const latest = getLatestOutcome(outcomes)
  const score = latest?.scores?.['PHQ-SELF-HARM']
  return typeof score === 'number' && score > 0
}
